<div class="pc-shell" #pcShell data-hotkey="patient-search">

  <p-sidebar
    [(visible)]="isPatientVisible"
    position="left"
    [modal]="true"
    [dismissible]="true"
    styleClass="pc-queue-drawer"
    [style]="{ width: 'min(440px, 92vw)' }"
  >
    <div class="pc-sidebar">
    <div class="precon-sidebar-inner">
      <p-tabView
        [(activeIndex)]="patientIndex"
        id="leftTabView"
      >
        <!-- Queue Tab -->
        <p-tabPanel header="Queue">
          <div class="pc-queue-tab">
          <div class="qf-bar">
            <!-- Visit type chips -->
            <div class="qf-row">
              <button class="qf-chip" [class.qf-chip--active]="queueTypeFilter === 'all'"
                (click)="setQueueTypeFilter('all')">
                All <span class="qf-count">{{ queue.length }}</span>
              </button>
              <button class="qf-chip" [class.qf-chip--active]="queueTypeFilter === 'new'"
                (click)="setQueueTypeFilter('new')">
                New <span class="qf-count">{{ queueNewCount }}</span>
              </button>
              <button class="qf-chip" [class.qf-chip--active]="queueTypeFilter === 'follow_up'"
                (click)="setQueueTypeFilter('follow_up')">
                Follow-up <span class="qf-count">{{ queueFollowUpCount }}</span>
              </button>
            </div>
            <!-- Mode chips + refresh -->
            <div class="qf-row">
              <button class="qf-chip" [class.qf-chip--active]="queueModeFilter === 'all'"
                (click)="setQueueModeFilter('all')">All</button>
              <button class="qf-chip qf-chip--opd" [class.qf-chip--active]="queueModeFilter === 'OPD'"
                (click)="setQueueModeFilter('OPD')">OPD <span class="qf-count">{{ queueOpdCount }}</span></button>
              <button class="qf-chip qf-chip--courier" [class.qf-chip--active]="queueModeFilter === 'COURIER'"
                (click)="setQueueModeFilter('COURIER')">Courier <span class="qf-count">{{ queueCourierCount }}</span></button>
              <button class="qf-chip qf-chip--nri" [class.qf-chip--active]="queueModeFilter === 'NRI'"
                (click)="setQueueModeFilter('NRI')">NRI <span class="qf-count">{{ queueNriCount }}</span></button>
              <button class="qf-chip qf-chip--mc" [class.qf-chip--active]="queueModeFilter === 'MC'"
                (click)="setQueueModeFilter('MC')">MC <span class="qf-count">{{ queueMedicineCollectionCount }}</span></button>
              <button class="qf-refresh" (click)="refreshQueue()" [disabled]="isQueueRefreshing" title="Refresh Queue">
                <i class="pi pi-refresh" [class.pi-spin]="isQueueRefreshing"></i>
              </button>
            </div>
          </div>

            <!-- Now Serving Section (fixed above scroll) -->
            <div class="modern-queue-section modern-queue-section--serving" *ngIf="nowServingPatient">
              <div class="section-title text-success">
                <i class="pi pi-play me-2"></i>Now Serving
              </div>
              <div class="modern-queue-list">
                <button
                  tabindex="0"
                  class="list-group-item list-group-item-action modern-queue-card active-serving"
                  (click)="selectPatient(nowServingPatient)"
                >
                  <div class="card-left-border border-green"></div>
                  <div class="card-content">
                    <div class="card-row-1">
                      <span class="queue-number">#{{ nowServingPatient.index + 1 }}</span>
                      <span class="patient-name">{{ nowServingPatient.name | uppercase }}</span>
                    </div>
                    <div class="card-row-2 text-muted">
                      <span class="visit-type">{{ getAppointmentTypeLabel(nowServingPatient.appointment_type) }}</span>
                      <span *ngIf="nowServingPatient.gender" class="dot-separator">•</span>
                      <span *ngIf="nowServingPatient.gender" class="metadata-label">
                        {{ nowServingPatient.gender | titlecase }}<ng-container *ngIf="nowServingPatient.age"> {{ nowServingPatient.age }}y</ng-container>
                      </span>
                      <span class="dot-separator">•</span>
                      <span class="wait-time text-success fw-bold">In Consultation</span>
                    </div>
                    <div class="card-row-3 text-muted mt-1">
                      <span class="draft-indicator" pTooltip="In Consultation" tooltipPosition="top">
                        <i class="pi pi-play-circle text-success" style="font-size:12px"></i>
                      </span>
                      <span class="dot-separator">•</span>
                      <span class="appt-time">
                        <i class="pi pi-clock me-1" style="font-size:10px"></i>{{ nowServingPatient.time }}
                      </span>
                      <span class="dot-separator">•</span>
                      <span class="mode-label">
                        <i class="pi pi-tag me-1" style="font-size:10px"></i>{{ getModeTitle(nowServingPatient.is_courier) }}
                      </span>
                      <span *ngIf="isMedicineCollectionItem(nowServingPatient)" class="dot-separator">•</span>
                      <span *ngIf="isMedicineCollectionItem(nowServingPatient)" class="mode-label text-warning">
                        <i class="pi pi-box me-1" style="font-size:10px"></i>MC
                      </span>
                    </div>
                  </div>
                </button>
              </div>
            </div>

            <!-- Up Next: fixed header + scrollable patient list -->
            <div class="modern-queue-section modern-queue-section--up-next" [class.mt-3]="nowServingPatient">
              <div class="up-next-head">
                <span class="up-next-head__icon" aria-hidden="true">
                  <i class="pi pi-list"></i>
                </span>
                <div class="up-next-head__copy">
                  <span class="up-next-head__title">Up Next</span>
                  <span class="up-next-head__sub">Waiting to be called</span>
                </div>
              </div>
              <div class="modern-queue-list modern-queue-list--scroll">
                  <ng-container *ngFor="let item of queue; let i = index">
                    <button
                      *ngIf="isQueueItemVisible(item) && i !== nowServingIndex"
                      tabindex="0"
                      class="list-group-item list-group-item-action modern-queue-card"
                      [ngClass]="[getModernStatusColorClass(item), isNextPatient(i) ? 'next-patient-row' : '']"
                      (click)="selectPatient(item)"
                    >
                      <div class="card-left-border" [ngClass]="getModernStatusColorClass(item)"></div>
                      <div class="card-content">
                        <div class="card-row-1">
                          <span class="queue-number">#{{ i + 1 }}</span>
                          <span class="patient-name">{{ item.name | uppercase }}</span>
                          <span *ngIf="isNextPatient(i)" class="next-chip ms-auto" title="Next patient in queue">NEXT</span>
                        </div>
                        <div class="card-row-2 text-muted">
                          <span class="visit-type">{{ getAppointmentTypeLabel(item.appointment_type) }}</span>
                          <span *ngIf="item.gender" class="dot-separator">•</span>
                          <span *ngIf="item.gender" class="metadata-label">
                            {{ item.gender | titlecase }}<ng-container *ngIf="item.age"> {{ item.age }}y</ng-container>
                          </span>
                          <span class="dot-separator">•</span>
                          <span class="wait-time" [ngClass]="getWaitTimeColorClass(getWaitTimeLabel(item.raw_time))">
                            {{ getWaitTimeLabel(item.raw_time) }}
                          </span>
                        </div>
                        <div class="card-row-3 text-muted mt-1">
                          <span
                            class="draft-indicator"
                            [pTooltip]="item.status === 'assistant_doctor_done' ? 'Assistant Draft Saved' : 'No Draft Yet'"
                            tooltipPosition="top"
                          >
                            <i
                              class="pi"
                              [ngClass]="item.status === 'assistant_doctor_done' ? 'pi-check-circle text-success' : 'pi-circle text-400'"
                              style="font-size:12px"
                            ></i>
                          </span>
                          <span
                            class="lifecycle-label text-xs fw-semibold ms-1"
                            [ngStyle]="{ color: item.status === 'assistant_doctor_done' ? '#10b981' : 'inherit' }"
                          >
                            {{ getQueueLifecycleLabel(item) }}
                          </span>
                          <span class="dot-separator ms-2">•</span>
                          <span class="appt-time">
                            <i class="pi pi-clock me-1" style="font-size:10px"></i>{{ item.time }}
                          </span>
                          <span class="dot-separator">•</span>
                          <span class="mode-label">
                            <i class="pi pi-tag me-1" style="font-size:10px"></i>{{ getModeTitle(item.is_courier) }}
                          </span>
                          <span *ngIf="isMedicineCollectionItem(item)" class="dot-separator">•</span>
                          <span *ngIf="isMedicineCollectionItem(item)" class="mode-label text-warning">
                            <i class="pi pi-box me-1" style="font-size:10px"></i>MC
                          </span>
                        </div>
                      </div>
                    </button>
                  </ng-container>
              </div>
            </div>
          </div>
        </p-tabPanel>

        <!-- Search Tab -->
        <p-tabPanel header="Search">
          <div class="pc-search-tab">
          <div class="search-visit-panel">
            <div class="search-visit-panel__head">
              <div class="search-visit-panel__icon" aria-hidden="true">
                <i class="pi pi-users"></i>
              </div>
              <div>
                <div class="search-visit-panel__title">Find a patient</div>
                <div class="search-visit-panel__subtitle">
                  Search by name, number, or contact
                </div>
              </div>
            </div>

            <div class="search-field w-100">
              <label class="search-field-label">Patient Search</label>
              <div class="patient-search-field">
                <i class="pi pi-search patient-search-field__icon" aria-hidden="true"></i>
                <p-autoComplete
                [(ngModel)]="selectedPatient"
                [suggestions]="patientsList"
                (completeMethod)="searchPatients($event)"
                (onSelect)="onPatientSelect($event)"
                field="full_name"
                dataKey="id"
                placeholder="Search by name, number, or contact"
                [forceSelection]="true"
                [minLength]="1"
                scrollHeight="320px"
                appendTo="body"
                [autoZIndex]="true"
                [baseZIndex]="2000"
                class="w-100"
                styleClass="w-100 patient-search-ac"
                inputStyleClass="patient-search-ac-input"
                panelStyleClass="patient-search-ac-panel"
                emptyMessage="No patients found"
                (onShow)="onPatientSearchOverlayShow()"
                (onHide)="onPatientSearchOverlayHide()"
              >
                <ng-template let-patient pTemplate="item">
                  <div class="patient-search-item">
                    <div class="patient-search-item__avatar" aria-hidden="true">
                      {{ getPatientSearchInitials(patient) }}
                    </div>
                    <div class="patient-search-item__body">
                      <div class="patient-search-item__name">
                        {{ buildPatientDisplayName(patient) }}
                      </div>
                      <div class="patient-search-item__meta">
                        <span
                          class="patient-search-chip"
                          *ngIf="patient.patient_number"
                        >
                          <i class="pi pi-id-card"></i>
                          {{ patient.patient_number }}
                        </span>
                        <span
                          class="patient-search-chip"
                          *ngIf="patient.primary_contact"
                        >
                          <i class="pi pi-phone"></i>
                          {{ patient.primary_contact }}
                        </span>
                        <span
                          class="patient-search-chip"
                          *ngIf="patient.gender"
                        >
                          <i class="pi pi-user"></i>
                          {{ patient.gender }}
                        </span>
                      </div>
                    </div>
                    <i class="pi pi-chevron-right patient-search-item__go"></i>
                  </div>
                </ng-template>
                <ng-template pTemplate="empty">
                  <div class="patient-search-empty">
                    <i class="pi pi-search"></i>
                    <span>No patients found</span>
                    <small>Try a name, patient number, or contact</small>
                  </div>
                </ng-template>
              </p-autoComplete>
              </div>
            </div>
            <div class="search-field w-100">
              <label class="search-field-label">Visit Type</label>
              <div class="search-visit-seg" role="radiogroup" aria-label="Visit Type">
                <button
                  *ngFor="let opt of searchVisitTypeOptions"
                  type="button"
                  class="search-visit-seg__btn"
                  [class.is-active]="searchVisitType === opt.value"
                  [attr.aria-pressed]="searchVisitType === opt.value"
                  (click)="searchVisitType = opt.value"
                >
                  <i
                    class="pi"
                    [ngClass]="{
                      'pi-bolt': opt.value === 'auto',
                      'pi-plus': opt.value === 'new',
                      'pi-replay': opt.value === 'follow_up'
                    }"
                  ></i>
                  {{ opt.label }}
                </button>
              </div>
              <div class="search-field-hint">
                <i class="pi pi-info-circle"></i>
                <span *ngIf="searchVisitType === 'auto'"
                  >Auto uses patient history to choose new or follow up.</span
                >
                <span *ngIf="searchVisitType === 'new'"
                  >Starts this visit as a new consultation.</span
                >
                <span *ngIf="searchVisitType === 'follow_up'"
                  >Starts this visit as a follow up.</span
                >
              </div>
            </div>
          </div>
          </div>
        </p-tabPanel>

      </p-tabView>
    </div>
    </div>
  </p-sidebar>

  <button
    *ngIf="!isPatientVisible"
    type="button"
    class="pc-queue-fab"
    (click)="openQueueSidebar()"
    pTooltip="Open queue"
    tooltipPosition="right"
    aria-label="Open queue"
  >
    <i class="pi pi-users"></i>
  </button>

  <!-- ══════════════════════════════════════════════════════════════════
       MAIN PANEL
  ══════════════════════════════════════════════════════════════════ -->
  <main class="pc-main">

    <!-- ── Empty state ──────────────────────────────────────────── -->
    <div class="pc-no-patient" *ngIf="!patient.patient_id && !patient.first_name">
      <div class="pc-no-patient-icon">
        <i class="pi pi-user-plus"></i>
      </div>
      <h5>Select a patient to begin</h5>
      <p>Open the queue on the left, or search for a patient.</p>
    </div>

    <!-- ── Patient panel ────────────────────────────────────────── -->
    <ng-container *ngIf="patient.patient_id || patient.first_name">

      <!-- Patient identity bar -->
      <div class="pc-patient-bar" [ngClass]="'pc-bar--' + (preconsultation.is_courier || 'OPD').toLowerCase()">
        <div class="pc-patient-avatar">
          <i class="pi pi-user"></i>
        </div>

        <div class="pc-patient-info">
          <div class="pc-patient-name">
            {{ patient.first_name }} {{ patient.middle_name }} {{ patient.last_name }}
            <span class="pc-patient-pid" *ngIf="patient.patient_number">#{{ patient.patient_number }}</span>
          </div>
          <div class="pc-patient-meta">
            <span class="pc-meta-chip" *ngIf="patient.age">
              <i class="pi pi-calendar-clock"></i>{{ patient.age }} yrs
            </span>
            <span class="pc-meta-chip" *ngIf="patient.gender">
              {{ patient.gender | titlecase }}
            </span>
            <span class="pc-meta-chip pc-meta-blood" *ngIf="patient.blood_group">
              {{ patient.blood_group }}
            </span>
            <span class="pc-meta-chip pc-meta-free" *ngIf="patient.is_free">
              <i class="pi pi-star-fill"></i> Free
            </span>
          </div>
        </div>

        <div class="pc-patient-bar-actions">
          <div class="pc-mode-wrap">
            <span class="pc-mode-label">Mode</span>
            <p-dropdown
              [options]="preconsultationModeOptions"
              [(ngModel)]="preconsultation.is_courier"
              optionLabel="label"
              optionValue="value"
              styleClass="pc-mode-dd"
              appendTo="body"
            />
          </div>
          <button class="pc-notes-btn" (click)="openDoctorNotesDialog()" [disabled]="!patient.patient_id" title="Doctor Notes">
            <i class="pi pi-comments"></i>
            <span>Dr. Notes</span>
          </button>
        </div>
      </div>

      <!-- Main tabs -->
      <p-tabView
        [(activeIndex)]="activeIndex"
        styleClass="pc-main-tabs"
        [class.pc-main-tabs--reports]="activeIndex === reportsTabIndex"
        [class.pc-main-tabs--history]="activeIndex === historyTabIndex"
        (onChange)="onMainTabChange($event)"
      >

        <!-- ══ Tab 1: Patient (vitals + notes) ══════════════════ -->
        <p-tabPanel header="Patient">
          <div class="pc-patient-panel">
          <div class="pc-patient-tab">

            <!-- Vitals strip -->
            <div class="pc-vitals-section">
              <div class="pc-vsec-label">
                <i class="pi pi-chart-line"></i> Vitals
              </div>
              <div class="pc-vitals-strip">

                <div class="pc-vslot pc-vslot--bp">
                  <div class="pc-vslot-top">
                    <i class="pi pi-heart-fill"></i>
                    <span class="pc-vslot-label">BP</span>
                  </div>
                  <input name="blood_pressure" type="text" placeholder="120/80"
                    [(ngModel)]="preconsultation.blood_pressure" autocomplete="off" />
                  <span class="pc-vslot-unit">mmHg</span>
                </div>

                <div class="pc-vslot pc-vslot--pulse">
                  <div class="pc-vslot-top">
                    <i class="pi pi-wave-pulse"></i>
                    <span class="pc-vslot-label">Pulse</span>
                  </div>
                  <input name="pulse_rate" type="number" placeholder="72"
                    [(ngModel)]="preconsultation.pulse_rate" autocomplete="off" />
                  <span class="pc-vslot-unit">bpm</span>
                </div>

                <div class="pc-vslot pc-vslot--temp">
                  <div class="pc-vslot-top">
                    <i class="pi pi-sun"></i>
                    <span class="pc-vslot-label">Temp</span>
                  </div>
                  <input name="temperature" type="number" placeholder="98.6"
                    [(ngModel)]="preconsultation.temperature" autocomplete="off" />
                  <span class="pc-vslot-unit">°F</span>
                </div>

                <div class="pc-vslot pc-vslot--weight">
                  <div class="pc-vslot-top">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 4px; display: inline-block;">
                      <rect x="3" y="5" width="18" height="14" rx="2" ry="2"></rect>
                      <path d="M9 5v4h6V5"></path>
                      <path d="M12 9L12 7"></path>
                    </svg>
                    <span class="pc-vslot-label">Weight</span>
                  </div>
                  <input name="weight" type="number" placeholder="70"
                    [(ngModel)]="preconsultation.weight" autocomplete="off" />
                  <span class="pc-vslot-unit">kg</span>
                </div>

                <div class="pc-vslot pc-vslot--height">
                  <div class="pc-vslot-top">
                    <i class="pi pi-arrows-v"></i>
                    <span class="pc-vslot-label">Height</span>
                  </div>
                  <input name="height" type="number" placeholder="170"
                    [(ngModel)]="preconsultation.height" autocomplete="off" />
                  <span class="pc-vslot-unit">cm</span>
                </div>

                <div class="pc-vslot pc-vslot--fbs">
                  <div class="pc-vslot-top">
                    <i class="pi pi-bolt"></i>
                    <span class="pc-vslot-label">FBS</span>
                  </div>
                  <input name="fasting_blood_sugar" type="number" placeholder="90"
                    [(ngModel)]="preconsultation.fasting_blood_sugar" autocomplete="off" />
                  <span class="pc-vslot-unit">mg/dL</span>
                </div>

                <div class="pc-vslot pc-vslot--spo2">
                  <div class="pc-vslot-top">
                    <i class="pi pi-cloud"></i>
                    <span class="pc-vslot-label">SpO₂</span>
                  </div>
                  <input name="blood_oxygen" type="number" placeholder="98"
                    [(ngModel)]="preconsultation.blood_oxygen" autocomplete="off" />
                  <span class="pc-vslot-unit">%</span>
                </div>

                <!-- Symptom toggles inline -->
                <div class="pc-vsymptoms">
                  <label class="pc-symptom-chip" [class.active]="preconsultation.runny_nose" for="runnyNose">
                    <input id="runnyNose" type="checkbox" [(ngModel)]="preconsultation.runny_nose" />
                    <i class="pi pi-inbox"></i> Cold / Runny Nose
                  </label>
                  <label class="pc-symptom-chip" [class.active]="preconsultation.cough" for="cough">
                    <input id="cough" type="checkbox" [(ngModel)]="preconsultation.cough" />
                    <i class="pi pi-microphone"></i> Cough
                  </label>
                </div>

              </div>
            </div>

            <!-- Notes area -->
            <div class="pc-notes-area">

              <div class="pc-notes-top">
                <div class="pc-ncard pc-ncard--cc">
                  <div class="pc-ncard-header">
                    <span class="pc-ncard-icon cc"><i class="pi pi-pencil"></i></span>
                    <label for="ccInput">Chief Complaints</label>
                  </div>
                  <textarea
                    id="ccInput"
                    name="chief_complaints"
                    rows="6"
                    appAutoCapitalize
                    [(ngModel)]="preconsultation.chief_complaints"
                    (keydown)="onChiefComplaintKeydown($event)"
                    placeholder="Describe the patient's main complaints…"
                  ></textarea>
                </div>
                <div class="pc-ncard pc-ncard--notes">
                  <div class="pc-ncard-header">
                    <span class="pc-ncard-icon notes"><i class="pi pi-file-edit"></i></span>
                    <label>Notes</label>
                  </div>
                  <textarea name="notes" rows="6" appAutoCapitalize [(ngModel)]="preconsultation.notes" placeholder="Additional clinical notes…"></textarea>
                </div>
                <div class="pc-ncard pc-ncard--allergy">
                  <div class="pc-ncard-header">
                    <span class="pc-ncard-icon allergy"><i class="pi pi-exclamation-triangle"></i></span>
                    <label>Allergies</label>
                  </div>
                  <textarea name="allergies" rows="6" appAutoCapitalize [(ngModel)]="preconsultation.allergies" placeholder="Known allergies and reactions…"></textarea>
                </div>
              </div>

              <!-- Bottom row: 3 columns -->
              <div class="pc-notes-bottom">
                <div class="pc-ncard">
                  <div class="pc-ncard-header">
                    <span class="pc-ncard-icon meds"><i class="pi pi-box"></i></span>
                    <label>Current Medications</label>
                  </div>
                  <textarea name="current_medications" rows="6" appAutoCapitalize [(ngModel)]="preconsultation.current_medications" placeholder="Ongoing medications and doses…"></textarea>
                </div>
                <div class="pc-ncard">
                  <div class="pc-ncard-header">
                    <span class="pc-ncard-icon history"><i class="pi pi-clock"></i></span>
                    <label>Past &amp; Family History</label>
                  </div>
                  <textarea name="personal_family_history" rows="6" appAutoCapitalize [(ngModel)]="preconsultation.personal_family_history" placeholder="Personal and family medical history…"></textarea>
                </div>
                <div class="pc-ncard">
                  <div class="pc-ncard-header">
                    <span class="pc-ncard-icon surgical"><i class="pi pi-wrench"></i></span>
                    <label>Surgical History</label>
                  </div>
                  <textarea name="surgical_history" rows="6" appAutoCapitalize [(ngModel)]="preconsultation.surgical_history" placeholder="Past surgeries and procedures…"></textarea>
                </div>
              </div>

            </div>

            <div class="mt-3 mb-2" *ngIf="pdfSrc">
              <iframe [src]="pdfSrc" width="100%" height="600px" style="border: 1px solid #e2e8f0; border-radius: 10px;"></iframe>
            </div>

          </div>

          <!-- Sticky action bar -->
          <div class="pc-action-bar">
            <div class="pc-draft-chip" [ngClass]="'state-' + draftSaveState">
              <i [class]="draftStatusIcon"></i>
              <span>{{ draftSaveLabel }}</span>
            </div>
            <div class="pc-action-btns">
              <app-hotkey-help [inline]="true" />
              <button class="pc-btn pc-btn--ghost" type="button" [disabled]="!canClearDraftFlag" (click)="clearCurrentDraft($event)">
                <i class="pi pi-trash"></i> Clear Draft
              </button>
              <button class="pc-btn pc-btn--send" type="button" (click)="saveDraft()">
                <i class="pi pi-send"></i> Send to Doctor
              </button>
            </div>
          </div>

          </div>

        </p-tabPanel>

        <!-- ══ Tab 2: Personal ══════════════════════════════════ -->
        <p-tabPanel header="Personal">
          <div class="pc-personal-panel">
          <div class="pc-personal-grid">

            <!-- Contact card -->
            <section class="pc-info-card">
              <div class="pc-info-card-head">
                <div class="pc-info-card-icon pci--blue"><i class="pi pi-phone"></i></div>
                <span>Contact Details</span>
              </div>
              <div class="pc-facts-grid">
                <div class="pc-fact">
                  <div class="pc-fact-icon pfi--green"><i class="pi pi-mobile"></i></div>
                  <div class="pc-fact-body">
                    <span class="pc-fact-label">Primary Contact</span>
                    <span class="pc-fact-value" [class.pc-fact-empty]="!patient.primary_contact">
                      {{ patient.primary_contact || 'Not provided' }}
                    </span>
                  </div>
                </div>
                <div class="pc-fact">
                  <div class="pc-fact-icon pfi--teal"><i class="pi pi-phone"></i></div>
                  <div class="pc-fact-body">
                    <span class="pc-fact-label">Secondary Contact</span>
                    <span class="pc-fact-value" [class.pc-fact-empty]="!patient.secondary_contact">
                      {{ patient.secondary_contact || 'Not provided' }}
                    </span>
                  </div>
                </div>
                <div class="pc-fact">
                  <div class="pc-fact-icon pfi--purple"><i class="pi pi-users"></i></div>
                  <div class="pc-fact-body">
                    <span class="pc-fact-label">Referred By</span>
                    <span class="pc-fact-value" [class.pc-fact-empty]="!patient.referred_by">
                      {{ patient.referred_by || 'Not provided' }}
                    </span>
                  </div>
                </div>
                <div class="pc-fact">
                  <div class="pc-fact-icon pfi--amber"><i class="pi pi-calendar-plus"></i></div>
                  <div class="pc-fact-body">
                    <span class="pc-fact-label">First Visit</span>
                    <span class="pc-fact-value" [class.pc-fact-empty]="!patient.first_visit">
                      {{ patient.first_visit || 'Not provided' }}
                    </span>
                  </div>
                </div>
              </div>
            </section>

            <!-- Address card -->
            <section class="pc-info-card">
              <div class="pc-info-card-head">
                <div class="pc-info-card-icon pci--orange"><i class="pi pi-map-marker"></i></div>
                <span>Address</span>
              </div>

              <div class="pc-addr-block" *ngIf="patient.address; else noAddress">
                <i class="pi pi-home"></i>
                <span>{{ patient.address }}</span>
              </div>
              <ng-template #noAddress>
                <div class="pc-addr-empty"><i class="pi pi-map-marker"></i> No address on file</div>
              </ng-template>

              <div class="pc-location-row">
                <div class="pc-loc-chip" *ngIf="patient.city">
                  <i class="pi pi-building"></i>
                  <div class="pc-loc-content">
                    <span class="pc-loc-label">City</span>
                    <span class="pc-loc-value">{{ patient.city }}</span>
                  </div>
                </div>
                <div class="pc-loc-chip" *ngIf="patient.state">
                  <i class="pi pi-map"></i>
                  <div class="pc-loc-content">
                    <span class="pc-loc-label">State</span>
                    <span class="pc-loc-value">{{ patient.state }}</span>
                  </div>
                </div>
                <div class="pc-loc-chip" *ngIf="patient.country">
                  <i class="pi pi-globe"></i>
                  <div class="pc-loc-content">
                    <span class="pc-loc-label">Country</span>
                    <span class="pc-loc-value">{{ patient.country }}</span>
                  </div>
                </div>
                <div class="pc-loc-chip" *ngIf="patient.pincode">
                  <i class="pi pi-hashtag"></i>
                  <div class="pc-loc-content">
                    <span class="pc-loc-label">PIN</span>
                    <span class="pc-loc-value">{{ patient.pincode }}</span>
                  </div>
                </div>
              </div>
            </section>

          </div>
          </div>
        </p-tabPanel>

        <!-- ══ Tab 3: Reports ═══════════════════════════════════ -->
        <p-tabPanel header="Reports">
          <div class="pc-reports-panel">
          <div class="pc-reports-layout pc-reports-tab-root" #reportsLayout>

            <!-- ── Left: Upload tools ──────────────────────────── -->
            <div
              class="pc-reports-sidebar"
              [style.width.px]="reportsSidebarWidth"
              [style.flex]="'0 0 ' + reportsSidebarWidth + 'px'"
            >

              <!-- Drop zone -->
              <div class="pc-dropzone">
                <input id="docUpload" type="file" class="pc-file-input" multiple
                  accept="image/png,image/jpeg,image/jpg,application/pdf"
                  (change)="onFileSelect($event)" />
                <label for="docUpload" class="pc-dropzone-inner">
                  <div class="pc-dropzone-icon"><i class="pi pi-cloud-upload"></i></div>
                  <div class="pc-dropzone-title">Click to choose files</div>
                  <div class="pc-dropzone-sub">PNG, JPG or PDF &middot; max {{ reportUploadMaxMb }} MB each</div>
                </label>
              </div>

              <!-- Selected files preview -->
              <div class="pc-pending-files" *ngIf="pendingFiles.length">
                <div class="pc-pending-head">
                  <i class="pi pi-paperclip"></i>
                  {{ pendingFiles.length }} file{{ pendingFiles.length > 1 ? 's' : '' }} ready
                </div>
                <div class="pc-pending-list">
                  <div class="pc-pending-item" *ngFor="let f of pendingFiles">
                    <i class="pi" [ngClass]="f.type.startsWith('image/') ? 'pi-image' : 'pi-file-pdf'"></i>
                    <span class="pc-pending-name">{{ f.name }}</span>
                  </div>
                </div>
                <button class="pc-btn pc-btn--send w-100" (click)="onUploadSelectedFiles()">
                  <i class="pi pi-arrow-up-right"></i> Upload {{ pendingFiles.length }} file{{ pendingFiles.length > 1 ? 's' : '' }}
                </button>
              </div>

              <!-- Text report -->
              <div class="pc-text-report-card">
                <div class="pc-text-report-head">
                  <div class="pc-trc-icon"><i class="pi pi-file-edit"></i></div>
                  <span>Write a Text Report</span>
                </div>
                <input type="text" class="pc-trc-input" placeholder="Report title (optional)" appAutoCapitalize [(ngModel)]="reportTextTitle" />
                <textarea class="pc-trc-textarea pc-trc-textarea--large" rows="8" placeholder="Write the report content here…" appAutoCapitalize [(ngModel)]="reportTextContent"></textarea>
                <div class="pc-trc-counter" [class.pc-trc-counter--over]="isTextReportContentOverLimit()">
                  {{ getTextReportCounterLabel() }}
                </div>
                <button class="pc-btn pc-btn--primary w-100" [disabled]="!reportTextContent.trim() || isSavingTextReport || isTextReportContentOverLimit()" (click)="saveTextReport()">
                  <i class="pi" [ngClass]="isSavingTextReport ? 'pi-spin pi-spinner' : 'pi-save'"></i>
                  {{ isSavingTextReport ? 'Saving…' : 'Save Text Report' }}
                </button>
              </div>

            </div>

            <div
              class="pc-reports-splitter"
              role="separator"
              aria-orientation="vertical"
              aria-label="Resize reports panels"
              title="Drag to resize panels"
              [class.is-dragging]="reportsSplitterDragging"
              (mousedown)="startReportsResize($event)"
            ></div>

            <!-- ── Right: Document gallery ─────────────────────── -->
            <div class="pc-reports-gallery">

              <div class="pc-gallery-toolbar">
                <div class="pc-gallery-toolbar-title">
                  <i class="pi pi-folder"></i>
                  Patient Documents
                </div>
                <span class="pc-gallery-total" *ngIf="uploadsByDate.length">
                  {{ uploadsByDate.length }} group{{ uploadsByDate.length > 1 ? 's' : '' }}
                </span>
              </div>

              <div class="pc-gallery-body">
              <ng-container *ngIf="uploadsByDate.length; else noUploads">
                <section *ngFor="let group of uploadsByDate" class="pc-gallery-group">
                  <div class="pc-gallery-date-head">
                    <span class="pc-gdh-day">{{ group.date | date:'EEEE' }}</span>
                    <span class="pc-gdh-date">{{ group.date | date:'d MMM yyyy' }}</span>
                    <span class="pc-gallery-count">{{ group.files.length }}</span>
                  </div>
                  <div class="pc-gallery-grid">
                    <article class="pc-gallery-item" *ngFor="let file of group.files" [class.pc-gallery-item--text]="isTextReport(file)" (click)="openFile(file)">
                      <button class="pc-gallery-delete" (click)="deleteUploadedReport(file, $event)" title="Delete">
                        <i class="pi pi-trash"></i>
                      </button>
                      <div class="pc-gallery-thumb">
                        <div class="pc-gallery-text" *ngIf="isTextReport(file); else pcGalleryThumbDefault">
                          <span class="pc-gallery-text__label">Text report</span>
                          <p class="pc-gallery-text__excerpt">{{ getTextReportExcerpt(file) }}</p>
                          <span class="pc-gallery-text__meta">
                            <i class="pi pi-align-left"></i>
                            {{ getTextReportLineCount(file) }} line{{ getTextReportLineCount(file) === 1 ? '' : 's' }}
                          </span>
                        </div>
                        <ng-template #pcGalleryThumbDefault>
                        <ng-container *ngIf="file.kind !== 'text' && file.type?.startsWith('image/')">
                          <img [src]="file.url" class="pc-gallery-img" alt="report" />
                        </ng-container>
                        <ng-container *ngIf="file.kind !== 'text' && !file.type?.startsWith('image/')">
                          <div class="pc-gthumb-icon pc-gthumb--pdf"><i class="pi pi-file-pdf"></i></div>
                        </ng-container>
                        </ng-template>
                      </div>
                      <div class="pc-gallery-meta">
                        <div class="pc-gallery-name" [title]="file.name">{{ file.name }}</div>
                        <span class="pc-gallery-badge"
                          [ngClass]="file.kind === 'text' ? 'gb--text' : file.type?.startsWith('image/') ? 'gb--img' : 'gb--pdf'">
                          {{ file.kind === 'text' ? 'Text' : file.type?.startsWith('image/') ? 'Image' : 'PDF' }}
                        </span>
                      </div>
                    </article>
                  </div>
                </section>
              </ng-container>

              <ng-template #noUploads>
                <div class="pc-gallery-empty">
                  <div class="pc-gallery-empty-icon"><i class="pi pi-folder-open"></i></div>
                  <p>No documents uploaded yet</p>
                  <span>Use the panel on the left to upload files or write a text report.</span>
                </div>
              </ng-template>
              </div>

            </div>

          </div>
          </div>
        </p-tabPanel>

        <!-- ══ Tab 4: History ════════════════════════════════════ -->
        <p-tabPanel header="History">
          <div class="pc-history-panel">
          <section class="pc-history-shell">

            <header class="pc-history-toolbar">
              <div>
                <h6 class="pc-history-title">Patient Timeline</h6>
                <span class="pc-history-count">
                  Showing <strong>{{ filteredRecords.length }}</strong>
                  of <strong>{{ historyTotalRecords || filteredRecords.length }}</strong> visits
                </span>
              </div>
              <button class="pc-btn pc-btn--ghost" (click)="refreshHistory()" [disabled]="historyLoading">
                <i class="pi pi-refresh"></i> Refresh
              </button>
            </header>

            <div class="pc-history-alert" *ngIf="historyError">
              <i class="pi pi-exclamation-circle"></i> {{ historyError }}
            </div>
            <div class="pc-history-loading" *ngIf="historyLoading && !filteredRecords.length">
              <i class="pi pi-spin pi-spinner"></i> Loading visits…
            </div>

            <div class="pc-history-body">
              <div class="pc-history-grid" *ngIf="filteredRecords.length">
                <aside class="pc-history-list">
                  <button
                    *ngFor="let record of filteredRecords; let i = index; trackBy: trackByHistoryRecord"
                    class="pc-history-item"
                    [class.active]="selectedHistoryIndex === i"
                    (click)="selectHistoryRecord(i)"
                  >
                    <div class="pc-hi-dot" [ngClass]="getAppointmentClass(record.appointment_type)"></div>
                    <div class="pc-hi-info">
                      <div class="pc-hi-date">
                        <span class="pc-hi-day">{{ record.visit_date | date:'EEE' }}</span>
                        <span class="pc-hi-full">{{ record.visit_date | date:'dd MMM yy' }}</span>
                      </div>
                      <div class="pc-hi-chips">
                        <span *ngIf="record.appointment_type" class="pc-hi-chip" [ngClass]="getAppointmentClass(record.appointment_type)">
                          {{ record.appointment_type | titlecase }}
                        </span>
                        <span class="pc-hi-chip neutral" *ngIf="record.personal_dues">
                          Due ₹{{ record.personal_dues | number:'1.0-0' }}
                        </span>
                      </div>
                    </div>
                  </button>
                  <div class="pc-history-list-load" *ngIf="historyHasMore">
                    <button
                      type="button"
                      class="pc-btn pc-btn--ghost pc-btn--block"
                      (click)="loadMoreHistory()"
                      [disabled]="historyLoadingMore"
                    >
                      <i class="pi" [ngClass]="historyLoadingMore ? 'pi-spin pi-spinner' : 'pi-angle-down'"></i>
                      {{ historyLoadingMore ? 'Loading…' : 'Load more' }}
                    </button>
                  </div>
                </aside>

                <article class="pc-history-detail" *ngIf="selectedHistoryRecord as record">
                  <header class="pc-hd-head">
                    <div class="pc-hd-title-block">
                      <div class="pc-hd-kicker"><i class="pi pi-calendar"></i> Visit Snapshot</div>
                      <h6 class="pc-hd-date">{{ record.visit_date | date:'fullDate' }}</h6>
                      <span *ngIf="record.appointment_type" class="pc-hi-chip" [ngClass]="getAppointmentClass(record.appointment_type)">
                        {{ record.appointment_type | titlecase }}
                      </span>
                    </div>
                    <div class="pc-hd-finance">
                      <div class="pc-finance-card fee">
                        <div class="lbl">Visit Fee</div>
                        <div class="val">{{ record.visit_fees ?? 0 | currency:'INR':'symbol':'1.0-0' }}</div>
                      </div>
                      <div class="pc-finance-card cash">
                        <div class="lbl">Cash</div>
                        <div class="val">{{ record.received_cash ?? 0 | currency:'INR':'symbol':'1.0-0' }}</div>
                      </div>
                      <div class="pc-finance-card online">
                        <div class="lbl">Online</div>
                        <div class="val">{{ record.received_online ?? 0 | currency:'INR':'symbol':'1.0-0' }}</div>
                      </div>
                      <div class="pc-finance-card due">
                        <div class="lbl">Due</div>
                        <div class="val">{{ record.personal_dues ?? 0 | currency:'INR':'symbol':'1.0-0' }}</div>
                      </div>
                    </div>
                  </header>

                  <section class="pc-hd-section" *ngIf="hasHistoryVitals(record)">
                    <div class="pc-hd-section-title"><i class="pi pi-heart-fill"></i> Vitals</div>
                    <div class="pc-hd-vitals">
                      <div class="pc-hv-card pc-hv-card--bp" *ngIf="record.blood_pressure">
                        <span class="k">BP</span>
                        <span class="v">{{ record.blood_pressure }}</span>
                        <span class="u">mmHg</span>
                      </div>
                      <div class="pc-hv-card pc-hv-card--pulse" *ngIf="record.pulse_rate">
                        <span class="k">Pulse</span>
                        <span class="v">{{ record.pulse_rate }}</span>
                        <span class="u">bpm</span>
                      </div>
                      <div class="pc-hv-card pc-hv-card--temp" *ngIf="record.temperature">
                        <span class="k">Temp</span>
                        <span class="v">{{ record.temperature }}</span>
                        <span class="u">°F</span>
                      </div>
                      <div class="pc-hv-card pc-hv-card--weight" *ngIf="record.weight">
                        <span class="k">Wt</span>
                        <span class="v">{{ record.weight }}</span>
                        <span class="u">kg</span>
                      </div>
                      <div class="pc-hv-card pc-hv-card--height" *ngIf="record.height">
                        <span class="k">Ht</span>
                        <span class="v">{{ record.height }}</span>
                        <span class="u">cm</span>
                      </div>
                      <div class="pc-hv-card pc-hv-card--fbs" *ngIf="record.fasting_blood_sugar">
                        <span class="k">FBS</span>
                        <span class="v">{{ record.fasting_blood_sugar }}</span>
                        <span class="u">mg/dL</span>
                      </div>
                      <div class="pc-hv-card pc-hv-card--spo2" *ngIf="record.blood_oxygen">
                        <span class="k">SpO₂</span>
                        <span class="v">{{ record.blood_oxygen }}</span>
                        <span class="u">%</span>
                      </div>
                    </div>
                  </section>

                  <section class="pc-hd-section">
                    <div class="pc-hd-section-title"><i class="pi pi-briefcase"></i> Clinical Notes</div>
                    <div class="row g-2" *ngIf="hasHistoryClinicalContent(record); else noHistoryClinicalNotes">
                      <div class="col-md-6" *ngIf="hasHistoryText(record.chief_complaints)">
                        <div class="pc-hd-note-card accent-blue">
                          <div class="pc-hd-note-title">Chief Complaints</div>
                          <ul class="pc-bullet-list" *ngIf="parseToArray(record.chief_complaints) as complaints">
                            <li *ngFor="let c of complaints">{{ c | titlecase }}</li>
                          </ul>
                          <p style="white-space:pre-line;margin:0" *ngIf="!parseToArray(record.chief_complaints)">
                            {{ record.chief_complaints }}
                          </p>
                        </div>
                      </div>
                      <div class="col-md-6" *ngIf="record.suggested_reports?.length">
                        <div class="pc-hd-note-card accent-purple">
                          <div class="pc-hd-note-title">Suggested Reports</div>
                          <ul class="pc-bullet-list">
                            <li *ngFor="let r of record.suggested_reports">{{ r | titlecase }}</li>
                          </ul>
                        </div>
                      </div>
                      <div class="col-md-6" *ngIf="record.allergies">
                        <div class="pc-hd-note-card accent-red">
                          <div class="pc-hd-note-title">Allergies</div>
                          <p style="white-space:pre-line;margin:0">{{ record.allergies }}</p>
                        </div>
                      </div>
                      <div class="col-md-6" *ngIf="record.current_medications">
                        <div class="pc-hd-note-card accent-green">
                          <div class="pc-hd-note-title">Current Medications</div>
                          <p style="white-space:pre-line;margin:0">{{ record.current_medications }}</p>
                        </div>
                      </div>
                      <div class="col-md-6" *ngIf="record.personal_family_history">
                        <div class="pc-hd-note-card accent-sky">
                          <div class="pc-hd-note-title">Family History</div>
                          <p style="white-space:pre-line;margin:0">{{ record.personal_family_history }}</p>
                        </div>
                      </div>
                      <div class="col-md-6" *ngIf="record.surgical_history">
                        <div class="pc-hd-note-card accent-teal">
                          <div class="pc-hd-note-title">Surgical History</div>
                          <p style="white-space:pre-line;margin:0">{{ record.surgical_history }}</p>
                        </div>
                      </div>
                      <div class="col-md-6" *ngIf="record.notes">
                        <div class="pc-hd-note-card accent-amber">
                          <div class="pc-hd-note-title">Notes</div>
                          <p style="white-space:pre-line;margin:0">{{ record.notes }}</p>
                        </div>
                      </div>
                      <div class="col-md-6" *ngIf="record.special_instructions">
                        <div class="pc-hd-note-card accent-indigo">
                          <div class="pc-hd-note-title">Special Instructions</div>
                          <p style="white-space:pre-line;margin:0">{{ record.special_instructions }}</p>
                        </div>
                      </div>
                    </div>
                    <ng-template #noHistoryClinicalNotes>
                      <div class="pc-hd-empty">No clinical notes recorded for this visit.</div>
                    </ng-template>
                  </section>
                </article>
              </div>

              <div class="pc-history-empty" *ngIf="!filteredRecords.length && !historyLoading">
                <i class="pi pi-info-circle"></i>
                <p>No history found for this patient.</p>
              </div>
            </div>

            <footer class="pc-history-footer" *ngIf="historyHasMore">
              <button class="pc-btn pc-btn--ghost" (click)="loadMoreHistory()" [disabled]="historyLoadingMore">
                <i class="pi" [ngClass]="historyLoadingMore ? 'pi-spin pi-spinner' : 'pi-angle-down'"></i>
                {{ historyLoadingMore ? 'Loading…' : 'Load more history' }}
              </button>
            </footer>

          </section>
          </div>
        </p-tabPanel>

      </p-tabView>
    </ng-container>

  </main>

</div>

<!-- Doctor Notes Dialog -->
<p-dialog
  header="Doctor Notes"
  [(visible)]="doctorNotesDialogVisible"
  [modal]="true"
  [maximizable]="true"
  [style]="{ width: '42rem' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="pc-dialog-tabs">
    <button class="pc-dialog-tab" [class.active]="doctorNotesTab === 'notes'" (click)="doctorNotesTab = 'notes'">Doctor Notes</button>
    <button class="pc-dialog-tab" [class.active]="doctorNotesTab === 'instructions'" (click)="doctorNotesTab = 'instructions'">Special Instructions</button>
  </div>

  <div *ngIf="doctorNotesTab === 'notes'">
    <div class="pc-note-latest" *ngIf="latestDoctorNote; else noDrNotes">
      <div class="pc-note-latest-title">Last Prescription Note <span *ngIf="latestDoctorNoteDate">({{ latestDoctorNoteDate }})</span></div>
      <div class="pc-note-latest-body">{{ latestDoctorNote }}</div>
    </div>
    <ng-template #noDrNotes>
      <div class="pc-note-empty">No previous doctor notes found.</div>
    </ng-template>
    <div class="pc-note-history" *ngIf="doctorNotesHistory.length > 1">
      <div class="pc-note-history-title">Older Notes</div>
      <ng-container *ngFor="let note of doctorNotesHistory; let i = index">
        <div *ngIf="i > 0" class="pc-note-history-item">
          <div class="pc-note-history-date">{{ note.date }}</div>
          <div class="pc-note-history-text">{{ note.notes }}</div>
        </div>
      </ng-container>
    </div>
  </div>

  <div *ngIf="doctorNotesTab === 'instructions'">
    <div class="pc-note-latest" *ngIf="latestSpecialInstruction; else noSI">
      <div class="pc-note-latest-title">Last Special Instruction <span *ngIf="latestSpecialInstructionDate">({{ latestSpecialInstructionDate }})</span></div>
      <div class="pc-note-latest-body">{{ latestSpecialInstruction }}</div>
    </div>
    <ng-template #noSI>
      <div class="pc-note-empty">No previous special instructions found.</div>
    </ng-template>
    <div class="pc-note-history" *ngIf="specialInstructionsHistory.length > 1">
      <div class="pc-note-history-title">Older Instructions</div>
      <ng-container *ngFor="let note of specialInstructionsHistory; let i = index">
        <div *ngIf="i > 0" class="pc-note-history-item">
          <div class="pc-note-history-date">{{ note.date }}</div>
          <div class="pc-note-history-text">{{ note.notes }}</div>
        </div>
      </ng-container>
    </div>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="textReportViewerVisible"
  [modal]="true"
  [style]="{ width: 'min(92vw, 720px)' }"
  [contentStyle]="{ padding: '0', overflow: 'hidden', display: 'flex', flexDirection: 'column', minHeight: '0' }"
  [draggable]="false"
  [resizable]="false"
  styleClass="trv-dialog"
  (onHide)="closeTextReportViewer()"
>
  <ng-template pTemplate="header">
    <div class="trv-head" *ngIf="viewingTextReport">
      <div class="trv-head__icon"><i class="pi pi-file-edit"></i></div>
      <div class="trv-head__copy">
        <span class="trv-head__eyebrow">Text report</span>
        <h2 class="trv-head__title">{{ viewingTextReport.name || 'Untitled report' }}</h2>
        <p class="trv-head__meta">
          <span *ngIf="viewingTextReport.uploaded_at">
            <i class="pi pi-calendar"></i> {{ viewingTextReport.uploaded_at }}
          </span>
          <span>
            <i class="pi pi-align-left"></i>
            {{ getTextReportLineCount(viewingTextReport) }} line{{ getTextReportLineCount(viewingTextReport) === 1 ? '' : 's' }}
          </span>
        </p>
      </div>
    </div>
  </ng-template>

  <div class="trv-body" *ngIf="viewingTextReport">
    <div class="trv-loading" *ngIf="textReportViewerLoading">
      <i class="pi pi-spin pi-spinner"></i>
      <span>Loading report…</span>
    </div>
    <div class="trv-content" *ngIf="!textReportViewerLoading">
      {{ getTextReportBody(viewingTextReport) }}
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="trv-footer">
      <button type="button" class="pc-btn pc-btn--ghost" (click)="copyTextReportContent()">
        <i class="pi pi-copy"></i> Copy text
      </button>
      <div class="trv-footer__actions">
        <button type="button" class="pc-btn pc-btn--primary" (click)="closeTextReportViewer()">
          Close
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-confirmPopup key="reportDeleteConfirm"></p-confirmPopup>
<p-confirmPopup key="clearDraftConfirm" styleClass="pc-draft-clear-popup">
  <ng-template pTemplate="content">
    <div class="pc-draft-clear-popup__body">
      <div class="pc-draft-clear-popup__icon" aria-hidden="true">
        <i class="pi pi-inbox"></i>
      </div>
      <div class="pc-draft-clear-popup__copy">
        <strong class="pc-draft-clear-popup__title">Clear saved draft?</strong>
        <p class="pc-draft-clear-popup__text">
          This removes the auto-saved pre-consultation draft for this patient.
          Fields on screen stay as they are.
        </p>
      </div>
    </div>
  </ng-template>
</p-confirmPopup>
